const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20scene%20with%20dramatic%20lighting%2C%20film%20strip%20texture%20overlay%2C%20warm%20golden%20and%20deep%20shadow%20contrast%2C%20movie%20screening%20atmosphere%2C%20dark%20theater%20with%20glowing%20screen%2C%20elegant%20cinematic%20composition&width=600&height=340&seq=media-01&orientation=landscape',
    title: '动作大片专区',
    desc: '热血激燃，燃爆视觉',
    tag: '热门',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Soft%20romantic%20cinematic%20lighting%20with%20warm%20amber%20tones%2C%20film%20grain%20texture%2C%20two%20silhouettes%20in%20golden%20sunset%20backlight%2C%20elegant%20movie%20poster%20aesthetic%2C%20dreamy%20bokeh%20background&width=600&height=340&seq=media-02&orientation=landscape',
    title: '爱情佳片精选',
    desc: '动人故事，温暖人心',
    tag: '推荐',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20suspenseful%20atmosphere%20with%20dramatic%20shadows%2C%20film%20noir%20style%2C%20dark%20alley%20with%20single%20golden%20streetlight%2C%20cinematic%20composition%20with%20grain%20texture%2C%20thriller%20movie%20aesthetic&width=600&height=340&seq=media-03&orientation=landscape',
    title: '悬疑烧脑剧场',
    desc: '层层反转，欲罢不能',
    tag: '新片',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Bright%20comedic%20scene%20with%20warm%20vibrant%20colors%2C%20playful%20cinematic%20lighting%2C%20joyful%20atmosphere%2C%20film%20poster%20style%20with%20soft%20golden%20highlights%2C%20cheerful%20movie%20theater%20vibe&width=600&height=340&seq=media-04&orientation=landscape',
    title: '爆笑喜剧合集',
    desc: '开怀大笑，解压首选',
    tag: '热播',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20atmosphere%20with%20deep%20space%20background%2C%20glowing%20neon%20amber%20accents%2C%20cinematic%20composition%2C%20film%20grain%20texture%2C%20dramatic%20lighting%20contrast%2C%20epic%20movie%20poster%20aesthetic&width=600&height=340&seq=media-05&orientation=landscape',
    title: '科幻视觉盛宴',
    desc: '脑洞大开，震撼视听',
    tag: '精选',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热门影片分类
          </h2>
          <p className="text-foreground-500 text-sm">精选五大类型，总有你喜欢的</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 max-w-6xl mx-auto">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer hover:scale-[1.02] transition-transform duration-300"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs whitespace-nowrap">
                  {item.tag}
                </span>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/80 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-play-fill text-2xl text-background-50 w-6 h-6 flex items-center justify-center"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading text-foreground-950 mb-1">{item.title}</h3>
                <p className="text-foreground-600 text-sm">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}